import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Lightbulb } from 'lucide-react';
const Container = styled.div`
  background: var(--vscode-editor-hoverHighlightBackground, rgba(255, 193, 7, 0.1));
  border: 1px solid var(--vscode-editorWarning-foreground, #FFC107);
  border-radius: var(--theme-radius-md, 8px);
  padding: var(--theme-spacing-lg, 24px);
  margin: var(--theme-spacing-lg, 24px) 0;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: var(--vscode-editorWarning-foreground, #FFC107);
    border-radius: 4px 0 0 4px;
  }
`;
const Title = styled.h4`
  color: var(--vscode-editor-foreground, var(--theme-text));
  margin: 0 0 var(--theme-spacing-md, 16px) 0;
  font-size: var(--theme-typography-font-size-base, 1rem);
  font-weight: var(--theme-typography-font-weight-semibold, 600);
  display: flex;
  align-items: center;
  gap: var(--theme-spacing-sm, 8px);
  
  svg {
    color: var(--vscode-editorWarning-foreground, #FFC107);
  }
`;
const Content = styled.div`
  color: var(--vscode-editor-foreground, var(--theme-text));
  font-size: var(--vscode-font-size, var(--theme-typography-font-size-sm, 0.875rem));
  line-height: 1.6;

  p {
    margin: 0 0 var(--theme-spacing-sm, 8px) 0;
    &:last-child {
      margin-bottom: 0;
    }
  }

  pre {
    margin: var(--theme-spacing-sm, 8px) 0;
  }

  code {
    background-color: var(--vscode-textCodeBlock-background, rgba(0, 0, 0, 0.1));
    padding: 0.2em 0.4em;
    border-radius: var(--theme-radius-sm, 4px);
    font-size: 0.9em;
  }
`;
const KeyConceptBox = ({ title = '핵심 개념', children })=>{
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsxs(Title, {
                children: [
                    /*#__PURE__*/ _jsx(Lightbulb, {
                        size: 20
                    }),
                    title
                ]
            }),
            /*#__PURE__*/ _jsx(Content, {
                children: children
            })
        ]
    });
};
// Default export for backward compatibility
export default KeyConceptBox;
